/**
 * SyncProgressBar — a thin, indeterminate progress bar pinned to the very top of
 * the screen while a SYNC (push+pull) is running. Deliberately does NOT show for
 * the background offline warm-up ("Caching offline…"), which the topbar pill
 * surfaces quietly instead — so a long warm-up never looks like sync is stuck.
 * Renders nothing when idle; success/failure are conveyed by the pill + toasts.
 */
import { useOffline } from "@/offline/OfflineProvider";

// Indeterminate sweep — a teal segment slides across the bar. Scoped keyframe
// name (icSyncBar) so it can't collide with the design system.
const CSS = `
@keyframes icSyncBar {
  0%   { left: -35%; width: 35%; }
  55%  { left: 55%;  width: 55%; }
  100% { left: 100%; width: 35%; }
}`;

export function SyncProgressBar() {
  const { phase } = useOffline();
  if (phase !== "syncing") return null;
  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-0 z-[200] h-[3px] overflow-hidden bg-primary/15"
      role="progressbar"
      aria-label="Syncing"
    >
      <style>{CSS}</style>
      <div
        className="absolute top-0 h-full rounded-full bg-primary"
        style={{ animation: "icSyncBar 1.1s ease-in-out infinite" }}
      />
    </div>
  );
}
